import {
    useMutation,
    UseMutationResult,
    useQuery,
    QueryResult,
    useSuspenseQuery,
} from '@eika-infrastruktur/react-query';
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import type { SalaryInfoRequest, SalaryInfoResponse } from '../generated-types';
import { deleteSalaryInfo, getSalaryInfo, saveSalaryInfo } from '../services/salaryInfoService';

const queryKey = ['salary-info'];

export const useSuspendedSalaryInfo = () => useSuspenseQuery({ queryKey, queryFn: getSalaryInfo });

const useSalaryInfo = (enabled?: boolean): QueryResult<SalaryInfoResponse | undefined> =>
    useQuery({ queryKey, queryFn: getSalaryInfo, enabled });

export const useMutateSalaryInfo = (): {
    save: UseMutationResult<unknown, RequestExceptionWithResponse, SalaryInfoResponse>;
    remove: UseMutationResult<unknown, RequestExceptionWithResponse, void>;
} => {
    const save = useMutation<unknown, RequestExceptionWithResponse, SalaryInfoRequest>({
        mutationKey: queryKey,
        mutationFn: saveSalaryInfo,
    });

    const remove = useMutation<unknown, RequestExceptionWithResponse, void>({
        mutationKey: queryKey,
        mutationFn: deleteSalaryInfo,
    });

    return { save, remove };
};
export default useSalaryInfo;
